import { validateFileType, validateMaxSize } from 'utils/validations';

export type UploadFileDescription = {
  size_bytes: number;
  type: string;
  extension: string;
  too_large: boolean;
  unsupported_type: boolean;
  rejected: boolean;
};

/**
 * Describes a picked upload file for logging: its size and format, and whether
 * client-side validation rejects it. Keys are snake_case to match the Datadog
 * log attributes.
 */
export default function describeUploadFile(file: Blob): UploadFileDescription {
  const extension =
    file instanceof File
      ? (/\.([^.]+)$/.exec(file.name)?.[1] ?? '').toLowerCase()
      : '';

  const tooLarge = Boolean(validateMaxSize(file));
  const unsupportedType = Boolean(validateFileType(file));

  return {
    size_bytes: file.size,
    type: file.type,
    extension,
    too_large: tooLarge,
    unsupported_type: unsupportedType,
    rejected: tooLarge || unsupportedType,
  };
}
